// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal_main {
    width: 100%;
    height: 100%;
    background: #00000099;
    position: absolute;

    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Quicksand;
}

/* MOdal boots */
.mdl-bdy {
    display: flex;
    flex-direction: column;
    /* gap: 1rem; */
    align-items: center;
    justify-content: space-around;
    padding: 3rem 2rem;
}

.succ-para {
    color: #000000;
    font-size: 33px;
    font-weight: 600;
    font-family: Quicksand;
    text-align: center;
}

.modal-content {
    color: var(--bs-modal-color);
    pointer-events: auto;
    background-color: var(--bs-modal-bg);
    background-clip: padding-box;


    border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
    border-radius: var(--bs-modal-border-radius);
    outline: 0;

    border-radius: 20px;
    border: 2px solid transparent;
    background: linear-gradient(180deg, #fcfdff 0%, #e2ecff 60%, #eef3fe 100%) padding-box, linear-gradient(180deg, #AC8642 0%, #E5C06B 49.5%, #B18B46 100%) border-box;

}

.fail-para {
    color: #000000;
    font-weight: 600;
    font-size: 18px;
    text-align: center;
    font-family: Quicksand;
    margin: 0px !important;
}

.fail-para-head {
    color: #000000;
    font-weight: bold;
    font-size: 22px;
    text-align: center;
    font-family: Quicksand;
    margin: 0px !important;
}

.modal-content {
    width: 420px;
    height: 400px;
}

.fail-symbol {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #D80303;
    font-size: 80px;
    font-weight: 700;
    color: #ffffff;
    padding-bottom: 1rem;
}

.modal-btn {
    box-shadow: 0px 4px 4px 0px #00000040;
    border-radius: 38px;
    padding: 8px;
    outline: none;
    border: 3px solid transparent;
    background: linear-gradient(90deg, #234B9A, #234B9A, #234B9A) padding-box, linear-gradient(180deg, #234B9A 0%, #FFFFFF 100%) border-box;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    width: 90%;
}

.modal-btn:hover {
    color: #234B9A;
    background: #ffffff;
    border: 3px solid #234B9A;
    font-weight: 600;
}

.modal-dialog-centered {
    justify-content: center;
}

@media screen and (max-width: 600px) {
    /* .modal-content {
        width: 300px !important;
        height: 280px !important;
    } */

    .succ-para {
        font-size: 20px;
    }

    .fail-symbol {
        width: 50px;
        height: 50px;
        font-size: 40px;
        padding-bottom: 10px;
    }

    .fail-para {
        font-size: 13px;
        margin-bottom: 0px !important;
    }

    .fail-para-head {
        font-size: 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Utils/popup/Popup.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;;IAElB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,oCAAoC;IACpC,4BAA4B;;;IAG5B,uEAAuE;IACvE,4CAA4C;IAC5C,UAAU;;IAEV,mBAAmB;IACnB,6BAA6B;IAC7B,mKAAmK;;AAEvK;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,uIAAuI;IACvI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI;;;OAGG;;IAEH;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,6BAA6B;IACjC;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".modal_main {\n    width: 100%;\n    height: 100%;\n    background: #00000099;\n    position: absolute;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: Quicksand;\n}\n\n/* MOdal boots */\n.mdl-bdy {\n    display: flex;\n    flex-direction: column;\n    /* gap: 1rem; */\n    align-items: center;\n    justify-content: space-around;\n    padding: 3rem 2rem;\n}\n\n.succ-para {\n    color: #000000;\n    font-size: 33px;\n    font-weight: 600;\n    font-family: Quicksand;\n    text-align: center;\n}\n\n.modal-content {\n    color: var(--bs-modal-color);\n    pointer-events: auto;\n    background-color: var(--bs-modal-bg);\n    background-clip: padding-box;\n\n\n    border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);\n    border-radius: var(--bs-modal-border-radius);\n    outline: 0;\n\n    border-radius: 20px;\n    border: 2px solid transparent;\n    background: linear-gradient(180deg, #fcfdff 0%, #e2ecff 60%, #eef3fe 100%) padding-box, linear-gradient(180deg, #AC8642 0%, #E5C06B 49.5%, #B18B46 100%) border-box;\n\n}\n\n.fail-para {\n    color: #000000;\n    font-weight: 600;\n    font-size: 18px;\n    text-align: center;\n    font-family: Quicksand;\n    margin: 0px !important;\n}\n\n.fail-para-head {\n    color: #000000;\n    font-weight: bold;\n    font-size: 22px;\n    text-align: center;\n    font-family: Quicksand;\n    margin: 0px !important;\n}\n\n.modal-content {\n    width: 420px;\n    height: 400px;\n}\n\n.fail-symbol {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #D80303;\n    font-size: 80px;\n    font-weight: 700;\n    color: #ffffff;\n    padding-bottom: 1rem;\n}\n\n.modal-btn {\n    box-shadow: 0px 4px 4px 0px #00000040;\n    border-radius: 38px;\n    padding: 8px;\n    outline: none;\n    border: 3px solid transparent;\n    background: linear-gradient(90deg, #234B9A, #234B9A, #234B9A) padding-box, linear-gradient(180deg, #234B9A 0%, #FFFFFF 100%) border-box;\n    color: #fff;\n    font-size: 16px;\n    font-weight: 600;\n    width: 90%;\n}\n\n.modal-btn:hover {\n    color: #234B9A;\n    background: #ffffff;\n    border: 3px solid #234B9A;\n    font-weight: 600;\n}\n\n.modal-dialog-centered {\n    justify-content: center;\n}\n\n@media screen and (max-width: 600px) {\n    /* .modal-content {\n        width: 300px !important;\n        height: 280px !important;\n    } */\n\n    .succ-para {\n        font-size: 20px;\n    }\n\n    .fail-symbol {\n        width: 50px;\n        height: 50px;\n        font-size: 40px;\n        padding-bottom: 10px;\n    }\n\n    .fail-para {\n        font-size: 13px;\n        margin-bottom: 0px !important;\n    }\n\n    .fail-para-head {\n        font-size: 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
